/**
 * Список рекламы
 * @return Promise
 */
const advList = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/advertising/getList",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Объект одной рекламы
 * data.id - обязательный параметр
 * @return Promise
 */
const advGet = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/advertising/get",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Удаление рекламы
 * @return Promise
 */
const deleteAdv = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/advertising/delete",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};
/**
 * Восстановление рекламы
 * @return Promise
 */
const recoveryAdv = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/advertising/recovery",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};
/**
 * Создание рекламы
 * @return Promise
 */
const createAdv = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/advertising/create",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};
/**
 * Дублирование рекламы
 * @return Promise
 */
const copyAdv = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/advertising/copy",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};
/**
 * Редактирование рекламы
 * @return Promise
 */
const editAdv = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/advertising/edit",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Список всей статистики рекламы
 * @return Promise
 */
const advStatsList = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/advertisingUser/getGraphData",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Список хотспотов рекламы
 * @return Promise
 */
const advHotspotList = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/advertisingUser/hotspotList",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

export {
  advList,
  advGet,
  editAdv,
  deleteAdv,
  recoveryAdv,
  createAdv,
  copyAdv,
  advStatsList,
  advHotspotList
};
